import React, {memo, useMemo} from 'react'
import {Skeleton, Alert, Typography, Steps} from 'antd'
import {StepsContainer} from './styles'
import {HeaderTitle} from '../../../../views/order-execution-plan/styles'
import {StagePlanItem, StagePlanItemI} from './stage-plan-item/stage-plan-item'
import {classNames} from '../../../../lib/classNames/classNames'


interface StagePlanProps {
  className?: string,
  items?: StagePlanItemI[],
  isLoading?: boolean,
  error?: string
  emptyMessage?: string
  title?: string
  hideHeader?: boolean
}

const {Text} = Typography;

const StagePlan: React.FC<StagePlanProps> = memo((props: StagePlanProps) => {
  const {
    className,
    items,
    isLoading,
    error,
    emptyMessage = 'План исполнения пуст',
    title = 'План исполнения',
    hideHeader
  } = props

  if (isLoading) {
    return <Skeleton active/>
  }

  if (!isLoading && error) {
    return <Alert
      message="При загрузке произошла ошибка"
      description={error}
      type="error"
    />
  }

  if (!isLoading && !error && (!items || !items?.length)) {
    return <Text>{emptyMessage}</Text>
  }

  const current = useMemo(() => {
    return items?.findIndex((stageItem) => stageItem.date_start && !stageItem.date_end)
  }, [items])

  return (
    <StepsContainer className={classNames('', {}, [className])}>
      { !hideHeader && (<HeaderTitle>{title}</HeaderTitle>) }
      <Steps size="small" current={current} direction="vertical">
        {
          items?.map((stageItem, index) => {
            return <Steps.Step
              key={`${stageItem?.code}${index}`}
              title={<StagePlanItem {...stageItem}/>}
              status={stageItem?.status || ((index === current) ? 'process' : 'wait')}
            />
          })
        }
      </Steps>
    </StepsContainer>
  )
})

export default StagePlan
